import { css } from '@/styled-system/css';

export const overlayContainer = css({
  pointerEvents: 'auto',
  position: 'absolute',
  zIndex: 'zIndexStep',
});
